import React, { useState } from "react"
import { Modal, Button, Space, Empty, Card, Flex } from "antd"
import { FileTextOutlined } from "@ant-design/icons"
import styles from "./index.module.css"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import TemplateEmptyImage from "ui/Icon/DSIcon/TemplateEmptyImage"
import bgMan from "assets/imagesV2/logo_man.svg"
import bgWoman from "assets/imagesV2/logo_woman.svg"
import { Text } from "ui/Typography"
import { useTheme } from "context/AntdThemeContext"
import ParticipatingModal from "../Participating"
import { themes } from "constants/theme"
import { useTranslation } from "react-i18next"
import CustomQuestions from "../CustomQuestions"

export const SignWaiver = ({bookingQuestionnaireId, open, onSignNow, onDoItLater, onCancel }) => {
  const { theme } = useTheme()
  const logoSrc = theme === themes.sportswoman ? bgWoman : bgMan
  const { t } = useTranslation()
  const [showParticipatingModal, setShowParticipatingModal] = useState(false)
  const [showCustomQuestionsModal, setShowCustomQuestionsModal] = useState(false)

  return (
    <>
      <Modal open={open} onCancel={onCancel} footer={null} centered width={800} className={styles.waiverModal} maskClosable={false}>
        <div>
          <h4> {t("embedded.booking_confirmation.digital_waiver")}</h4>
          <WithEmptyStateWrapper
            fallback={
              <Card className={styles.contentWrapper}>
                <Empty
                  image={<TemplateEmptyImage />}
                  description={
                    <>
                      <Text size="md" >{t("embedded.booking_confirmation.digital_waiver_desc")}</Text>
                      {/* <p style={{ color: "#888" }}></p> */}
                      <Flex gap={12} justify="center" align="center">
                        <Button color="primary" variant="solid" onClick={() => setShowParticipatingModal(true)}>
                          {t("embedded.booking_confirmation.sign_waiver")}
                        </Button>
                        <Button color="primary" variant="outlined" onClick={() => setShowCustomQuestionsModal(true)}>
                          {t("embedded.booking_confirmation.do_it_later")}
                        </Button>
                      </Flex>
                    </>
                  }
                />
              </Card>
            }
            hasItems={false}
            name="customTemplate"
            tag="div"
            className="vstack gap-20"
          ></WithEmptyStateWrapper>
          <Flex justify="space-between" align="center" gap={10} className={`mt-4xl ${styles.customQuestionsFooter}`}>
            <Flex align="center" gap={12} className={`${styles.poweredBy}`}>
              {t("settings.powered_by")}{" "}
              <span className={styles.logo}>
                <img className={styles.logoImage} src={logoSrc} alt="" />
              </span>
            </Flex>
            <Flex gap={8} className={styles.buttonGroup}>
              <Button color="primary" variant="outlined">
                {t("settings.previous")}
              </Button>
              <Button htmlType="submit" color="primary" variant="solid">
                {t("settings.submit")}
              </Button>
            </Flex>
          </Flex>
        </div>
      </Modal>
      <ParticipatingModal
        visible={showParticipatingModal}
        onCancel={() => setShowParticipatingModal(false)}
        onNext={() => setShowParticipatingModal(false)}
      />
      <CustomQuestions
        bookingQuestionnaireId={bookingQuestionnaireId}
        visible={showCustomQuestionsModal}
        onClose={() => setShowCustomQuestionsModal(false)}
      />
    </>
  )
}
